import CityPageTemplate from "../city-template/CityPageTemplate";
import { southBendConfig } from "./data";

export default function SouthBendPage() {
  return <CityPageTemplate config={southBendConfig} />;
}